import React from "react";
import DOMPurify from "dompurify";
import "./CommonButton.scss";
import { IconType } from "react-icons";

interface ButtonProps {
  btnText: string; // Text to display on the button
  onClick: () => void; // Function to execute when the button is clicked
  type?: "button" | "submit" | "reset"; // Button type (default is 'button')
  className?: string; // Custom CSS class for styling
  disabled?: boolean; // Disable button (default is false)
  loading?: boolean; // Loading state (default is false)
  color?: string;
  height?: string;
  width?: string;
  backgroundColor?: string; // Background color of the button (default is transparent)
  border?: string; // Border property (e.g., "2px solid #333")
  borderRadius?: string; // Border radius of the button (default is '4px')
  icon?: IconType; // Optional react-icon component to display before or after the text
  iconClass?: string; // Icon styling
  iconSize?: number | string;
}

const CommonButton: React.FC<ButtonProps> = ({
  btnText,
  onClick,
  type = "button",
  className = "",
  disabled = false,
  loading = false,
  color = "#000000",
  height = "40px",
  width = "",
  backgroundColor = "transparent",
  border = "none",
  borderRadius = "4px",
  icon,
  iconClass = "left",
  iconSize,
}: ButtonProps) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`common-button ${className} ${loading ? "loading" : ""}`}
      disabled={disabled || loading}
      style={{
        backgroundColor,
        border,
        borderRadius,
        color,
        height,
        width,
      }}>
      {/* {loading && <div className="loading-spinner"></div>} */}

      <span className="button-content" style={{ opacity: loading ? 0.7 : 1 }}>
        {icon && iconClass === "left" && (
          <span className="button-icon">
            {React.createElement(icon, iconSize ? { size: iconSize } : {})}
          </span>
        )}

        <span
          style={{ opacity: loading ? 0.7 : 1 }}
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(btnText) }}></span>

        {icon && iconClass === "right" && (
          <span className="button-icon">
            {React.createElement(icon, iconSize ? { size: iconSize } : {})}
          </span>
        )}
      </span>
    </button>
  );
};

export default CommonButton;
